// eslint-disable-next-line @typescript-eslint/ban-types
export function registerable(targetClass) {
    // Simple property used for type checking
    Object.defineProperty(targetClass.prototype, 'registerable', {
        value: true,
        writable: false,
        enumerable: false,
        configurable: false,
    });
    return targetClass;
}
